// --- GIFT BAG CART DRAWER ---
(function() {
  function isBagTitle(title) {
    return title.toUpperCase().includes('BOLSA DE REGALO');
  }

  function getCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function removeBagsByBundleId(bundleId) {
    return getCart().then(function(cart) {
      var bags = cart.items.filter(function(i) {
        return isBagTitle(i.title) && i.properties && i.properties._BundleId === bundleId;
      });
      if (!bags.length) return false;
      var updates = {};
      bags.forEach(function(bag) { updates[bag.key] = 0; });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() { return true; });
    });
  }

  function addBagToCart(variantId, bundleId) {
    if (typeof window.addGiftToCart === 'function') {
      return window.addGiftToCart(variantId, bundleId);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: { _BundleId: bundleId }
      })
    });
  }

  function setProductBundleId(itemKey, bundleId) {
    return getCart().then(function(cart) {
      var item = cart.items.find(function(i) { return i.key === itemKey; });
      if (!item) return;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, properties: { _BundleId: bundleId } })
      });
    });
  }

  function setCartDrawerOverlay(visible) {
    if (typeof window.toggleCartDrawerOverlay === 'function') {
      window.toggleCartDrawerOverlay(visible);
    }
  }

  function initGiftBagItems() {
    var wrappers = document.querySelectorAll('.gift-bag-item-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach(function(wrapper) {
      if (wrapper.dataset.initialized === 'true') return;

      var isProcessing = false;
      var checkbox = wrapper.querySelector('.gift-bag-item-input');
      var priceLabel = wrapper.querySelector('.gift-bag-item-price-label');
      var itemKey = wrapper.dataset.itemKey;
      var giftVariantId = wrapper.dataset.giftVariantId;

      if (!checkbox || !giftVariantId) return;

      wrapper.dataset.initialized = 'true';

      function updatePriceLabel() {
        if (priceLabel && wrapper.dataset.giftPriceFormatted) {
          priceLabel.textContent = wrapper.dataset.giftPriceFormatted;
        }
      }
      updatePriceLabel();

      function getBundleId() { return wrapper.dataset.bundleId || ''; }
      function setBundleId(id) { wrapper.dataset.bundleId = id; }

      function done() {
        wrapper.classList.remove('updating');
        var refresh = typeof window.refreshCartDrawer === 'function'
          ? window.refreshCartDrawer()
          : Promise.resolve();
        Promise.resolve(refresh).finally(function() {
          isProcessing = false;
          setCartDrawerOverlay(false);
        });
      }

      function fail(label, err) {
        console.error(label, err);
        isProcessing = false;
        wrapper.classList.remove('updating');
        setCartDrawerOverlay(false);
      }

      function addLinkedBag() {
        var availableSlots = parseInt(wrapper.dataset.availableSlots || '0', 10);
        var linkedBags = parseInt(wrapper.dataset.currentBags || '0', 10);
        var bundleId = getBundleId();

        if (linkedBags > 0) return;

        if (availableSlots <= 0) {
          checkbox.checked = false;
          return;
        }

        setCartDrawerOverlay(true);
        isProcessing = true;
        wrapper.classList.add('updating');

        if (!bundleId) {
          var newBundleId = Date.now() + '_' + Math.floor(Math.random() * 1000);
          setBundleId(newBundleId);
          setProductBundleId(itemKey, newBundleId)
            .then(function() { return addBagToCart(giftVariantId, newBundleId); })
            .then(done)
            .catch(function(err) {
              checkbox.checked = false;
              setBundleId('');
              setProductBundleId(itemKey, '').catch(function() {}).finally(function() {
                fail('Error adding bag:', err);
              });
            });
        } else {
          addBagToCart(giftVariantId, bundleId)
            .then(done)
            .catch(function(err) {
              checkbox.checked = false;
              fail('Error adding bag:', err);
            });
        }
      }

      checkbox.addEventListener('change', function(e) {
        e.stopPropagation();
        if (isProcessing) {
          this.checked = !this.checked;
          return;
        }

        if (this.checked) {
          addLinkedBag();
          return;
        }

        var bundleId = getBundleId();
        if (!bundleId) return;

        setCartDrawerOverlay(true);
        isProcessing = true;
        wrapper.classList.add('updating');

        removeBagsByBundleId(bundleId)
          .then(function(removed) {
            if (removed) return setProductBundleId(itemKey, '');
          })
          .then(function() {
            setBundleId('');
            done();
          })
          .catch(function(err) { fail('Error removing bags:', err); });
      });
    });
  }

  window.initGiftBagCartDrawerItems = initGiftBagItems;

  var giftBagDebounceId = null;
  function scheduleGiftBagObserverInit() {
    if (giftBagDebounceId) clearTimeout(giftBagDebounceId);
    giftBagDebounceId = setTimeout(function() {
      giftBagDebounceId = null;
      initGiftBagItems();
      if (typeof window.initCartDrawerValidation === 'function') window.initCartDrawerValidation();
    }, 50);
  }

  var giftBagObserver = new MutationObserver(function(mutations) {
    var shouldInit = false;
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        var hasGiftBag = Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 &&
            ((node.classList && node.classList.contains('gift-bag-item-wrapper')) ||
             (node.querySelector && node.querySelector('.gift-bag-item-wrapper')));
        });
        if (hasGiftBag) { shouldInit = true; break; }
      }
    }
    if (shouldInit) scheduleGiftBagObserverInit();
  });

  function attachGiftBagObserver() {
    var root = document.getElementById('CartDrawer') || document.body;
    giftBagObserver.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initGiftBagItems();
      attachGiftBagObserver();
    });
  } else {
    initGiftBagItems();
    attachGiftBagObserver();
  }
})();
// --- FIN GIFT BAG CART DRAWER ---

// --- CARRUSEL BOLSAS CART DRAWER (MOBILE) ---
(function() {
  function initCartDrawerRecommendationsCarousel(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var carousels = scope.querySelectorAll('.cart-recommendations-mobile-carousel');
    if (!carousels.length) return;

    carousels.forEach(function(carousel) {
      if (carousel.dataset.initialized === 'true') return;

      var track = carousel.querySelector('.cart-recommendations-table-mobile');
      var viewport = carousel.querySelector('.cart-recommendations-viewport');
      var items = track ? track.querySelectorAll('.cart-recommendations-cart-item-mobile') : [];
      var prevBtn = carousel.querySelector('.cart-recommendations-nav-prev');
      var nextBtn = carousel.querySelector('.cart-recommendations-nav-next');
      var dots = carousel.parentElement
        ? carousel.parentElement.querySelector('.cart-recommendations-dots')
        : null;

      if (!track || !viewport || !items.length || !prevBtn || !nextBtn || !dots) return;

      carousel.dataset.initialized = 'true';
      var currentIndex = 0;

      function renderDots() {
        dots.innerHTML = '';
        for (var i = 0; i < items.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cart-recommendations-dot';
          dot.setAttribute('aria-label', 'Ir a producto ' + (i + 1));
          dot.dataset.index = String(i);
          dots.appendChild(dot);
        }
      }

      function updateSlide(newIndex) {
        if (newIndex < 0) newIndex = 0;
        if (newIndex > items.length - 1) newIndex = items.length - 1;
        currentIndex = newIndex;

        var visibleWidth = viewport.clientWidth || 0;
        track.style.transform = 'translateX(-' + (currentIndex * visibleWidth) + 'px)';
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === items.length - 1;

        var dotNodes = dots.querySelectorAll('.cart-recommendations-dot');
        dotNodes.forEach(function(dot, idx) {
          dot.classList.toggle('is-active', idx === currentIndex);
        });
      }

      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var touchDeltaY = 0;
      var touchStartedOnInteractive = false;
      var isHorizontalSwipe = false;
      var SWIPE_THRESHOLD = 40;

      function isInteractiveTarget(target) {
        return Boolean(
          target &&
          target.closest &&
          target.closest('button, a, input, select, textarea, label, .cart-recommendations-button-add, .add-to-cart-form')
        );
      }

      if (items.length <= 1) {
        prevBtn.style.visibility = 'hidden';
        nextBtn.style.visibility = 'hidden';
        dots.style.display = 'none';
      } else {
        renderDots();
        dots.addEventListener('click', function(e) {
          var target = e.target.closest('.cart-recommendations-dot');
          if (!target) return;
          var idx = parseInt(target.dataset.index || '0', 10);
          if (!Number.isNaN(idx)) updateSlide(idx);
        });

        prevBtn.addEventListener('click', function() {
          updateSlide(currentIndex - 1);
        });

        nextBtn.addEventListener('click', function() {
          updateSlide(currentIndex + 1);
        });

        viewport.addEventListener('touchstart', function(e) {
          if (!e.touches || !e.touches.length) return;
          var touch = e.touches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          touchDeltaX = 0;
          touchDeltaY = 0;
          isHorizontalSwipe = false;
          touchStartedOnInteractive = isInteractiveTarget(e.target);
        }, { passive: true });

        viewport.addEventListener('touchmove', function(e) {
          if (touchStartedOnInteractive || !e.touches || !e.touches.length) return;
          var touch = e.touches[0];
          touchDeltaX = touch.clientX - touchStartX;
          touchDeltaY = touch.clientY - touchStartY;

          if (Math.abs(touchDeltaX) > 12 && Math.abs(touchDeltaX) > Math.abs(touchDeltaY)) {
            isHorizontalSwipe = true;
            e.preventDefault();
          }
        }, { passive: false });

        viewport.addEventListener('touchend', function() {
          if (touchStartedOnInteractive || !isHorizontalSwipe) return;

          if (touchDeltaX <= -SWIPE_THRESHOLD) {
            updateSlide(currentIndex + 1);
          } else if (touchDeltaX >= SWIPE_THRESHOLD) {
            updateSlide(currentIndex - 1);
          }
        });

        if (typeof ResizeObserver !== 'undefined') {
          var resizeObserver = new ResizeObserver(function() {
            updateSlide(currentIndex);
          });
          resizeObserver.observe(viewport);
        }
      }

      updateSlide(0);
    });
  }

  window.initCartDrawerRecommendationsCarousel = initCartDrawerRecommendationsCarousel;

  var recObserverDebounceId = null;
  function scheduleRecommendationsObserverInit() {
    if (recObserverDebounceId) clearTimeout(recObserverDebounceId);
    recObserverDebounceId = setTimeout(function() {
      recObserverDebounceId = null;
      var root = document.getElementById('CartDrawer') || document;
      initCartDrawerRecommendationsCarousel(root);
    }, 50);
  }

  var recommendationsObserver = new MutationObserver(function(mutations) {
    var shouldInit = false;

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        var hasCarousel = Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 &&
            ((node.classList && node.classList.contains('cart-recommendations-mobile-carousel')) ||
             (node.querySelector && node.querySelector('.cart-recommendations-mobile-carousel')));
        });
        if (hasCarousel) {
          shouldInit = true;
          break;
        }
      }
    }

    if (shouldInit) scheduleRecommendationsObserverInit();
  });

  function attachRecommendationsObserver() {
    var root = document.getElementById('CartDrawer') || document.body;
    recommendationsObserver.observe(root, { childList: true, subtree: true });
  }

  function runInitialCarouselInit() {
    var root = document.getElementById('CartDrawer') || document;
    initCartDrawerRecommendationsCarousel(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      runInitialCarouselInit();
      attachRecommendationsObserver();
    });
  } else {
    runInitialCarouselInit();
    attachRecommendationsObserver();
  }

  window.afterCartDrawerHtmlUpdated = function() {
    var root = document.getElementById('CartDrawer') || document;
    if (typeof window.initGiftBagCartDrawerItems === 'function') {
      window.initGiftBagCartDrawerItems();
    }
    if (typeof window.initCartDrawerValidation === 'function') {
      window.initCartDrawerValidation();
    }
    initCartDrawerRecommendationsCarousel(root);
  };
})();
// --- FIN CARRUSEL BOLSAS CART DRAWER (MOBILE) ---

window.addGiftToCart = async (giftId, bundleId = null) => {
  if (!giftId) return;

  let properties = { _Regalo: "Sí" };
  if (bundleId) {
    properties["_BundleId"] = bundleId;
  }

  try {
    const resp = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: giftId,
            quantity: 1,
            properties: properties,
          },
        ],
      }),
    });

    if (resp.ok) {
      if (window.refreshCartDrawer) await window.refreshCartDrawer();
      if (window.forceBagCorrection) await window.forceBagCorrection();
    }
  } catch (e) {
    console.error("Error agregando bolsa:", e);
  }
};

window.updateCardProductImages = (element) => {
  const cardWrapper = element.closest('.card-wrapper');
  const images = cardWrapper?.getElementsByClassName('featured_image');
  if (!element.dataset.featuredImg || !images?.length) return;

  const featuredImgURL = element.dataset.featuredImg;
  const secondImgURL = element.dataset.secondImg || featuredImgURL;
  images[0].src = featuredImgURL;
  images[0].srcset = featuredImgURL;

  if (images[1]) {
    images[1].src = secondImgURL;
    images[1].srcset = secondImgURL;
  }
};

window.updateCardProductPrice = (element) => {
  const cardWrapper = element.closest('.card-wrapper');
  if (!cardWrapper) return;

  const priceContainer = cardWrapper.querySelector('.price__container');
  if (!priceContainer) return;

  const price = element.dataset.price;
  const compareAtPrice = element.dataset.compareAtPrice;
  const hasCompare = element.dataset.hasCompare === 'true';

  const priceWrapper = cardWrapper.querySelector('.price');
  const existingDiv = priceContainer.querySelector('.price__sale') || priceContainer.querySelector('.price__regular');
  if (!existingDiv) return;

  if (hasCompare && compareAtPrice) {
    priceWrapper.classList.add('price--on-sale');
    priceWrapper.classList.remove('price--no-compare');

    const saleDiv = document.createElement('div');
    saleDiv.className = 'price__sale';
    saleDiv.innerHTML = `
      <span class="visually-hidden visually-hidden--inline">Precio regular</span>
      <span>
        <s class="price-item price-item--regular">${compareAtPrice}</s>
      </span>
      <span class="visually-hidden visually-hidden--inline">Precio de oferta</span>
      <span class="price-item price-item--sale price-item--last price-item--sale-with-compare">
        ${price}
      </span>
    `;
    existingDiv.replaceWith(saleDiv);
  } else {
    priceWrapper.classList.remove('price--on-sale');

    const regularDiv = document.createElement('div');
    regularDiv.className = 'price__regular';
    regularDiv.innerHTML = `
      <span class="price-item price-item--regular">
        ${price}
      </span>
    `;
    existingDiv.replaceWith(regularDiv);
  }
};

window.validateVariantSelected = (element, variantId) => {
  const cardWrapper = element.closest('.card-wrapper');
  if (!cardWrapper) return;

  const titleElement = cardWrapper.querySelector('.js-card-title');
  if (titleElement && element.dataset.variantName) {
    const variantName = element.dataset.variantName;
    titleElement.innerText = variantName === 'Default Title' 
      ? element.dataset.productTitle 
      : element.dataset.productTitle + ' ' + variantName;
  }

  const badgeDiscount = cardWrapper.querySelector('.badge-discount');
  if (badgeDiscount) {
    const discountValue = parseInt(element.dataset.discount);
    if (discountValue > 0) {
      badgeDiscount.innerText = '-' + discountValue + '%';
      badgeDiscount.style.display = 'block';
      badgeDiscount.classList.add('active');
    } else {
      badgeDiscount.style.display = 'none';
      badgeDiscount.classList.remove('active');
    }
  }

  const variantInputs = cardWrapper.querySelectorAll('.product-variant-id');
  variantInputs.forEach(input => input.value = variantId);

  const customButtons = cardWrapper.querySelectorAll('.custom-plp-add-btn');
  const isAvailable = !element.classList.contains('available-false');
  customButtons.forEach(btn => {
    btn.setAttribute('data-variant-id', variantId);
    btn.disabled = !isAvailable;
    const spanText = btn.querySelector('span');
    if (spanText) {
      spanText.innerText = isAvailable ? 'Agregar al carrito' : 'Agotado';
    }
  });

  const siblings = element.parentElement.children;
  Array.from(siblings).forEach(sibling => sibling.classList.remove('active'));
  element.classList.add('active');

  window.updateCardProductImages(element);
  window.updateCardProductPrice(element);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.variant-option-container ul').forEach(ul => {
    if (ul.querySelector('li.active')) return;
    const first = ul.querySelector('li.available-true') || ul.querySelector('li');
    if (first) first.classList.add('active');
  });
});

// Force autoplay for background videos on mobile
document.addEventListener('DOMContentLoaded', () => {
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('video[data-video-autoplay]').forEach(video => {
    videoObserver.observe(video);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('.custom-plp-add-btn');
    if (!btn || btn.classList.contains('loading')) return;

    btn.classList.add('loading');
    btn.disabled = true;

    const spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    try {
      const variantId = btn.getAttribute('data-variant-id');
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      const bundledItem = cart.items.find(
        item => item.variant_id == variantId && item.properties?._BundleId
      );

      const props = bundledItem ? { _BundleId: bundledItem.properties._BundleId } : {};

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: props,
        }),
      });

      await response.json();

      if (window.forceBagCorrection) await window.forceBagCorrection();
      if (window.refreshCartDrawer) await window.refreshCartDrawer();

      const drawerInner = document.querySelector('.drawer__inner');
      if (drawerInner) {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cartData => {
            if (cartData.item_count > 0) {
              drawerInner.classList.add('cart-drawer-pinflag-flex-column', 'cart-drawer-pinflag-width');
            } else {
              drawerInner.classList.remove('cart-drawer-pinflag-flex-column', 'cart-drawer-pinflag-width');
            }
          })
          .catch(err => console.warn('Error verificando estado del carrito:', err));
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        setTimeout(() => {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            cartDrawer.classList.add('active');
          }
        }, 200);
      }
    } catch (error) {
      console.error('Error al agregar al carrito:', error);
    } finally {
      btn.classList.remove('loading');
      btn.disabled = false;
      if (spinner) spinner.classList.add('hidden');
    }
  });
});

// Randomizar frases del badge de colección (1 frase aleatoria por instancia)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.badge-text--collection').forEach((node) => {
    const phraseEls = node.querySelectorAll('.badge-phrase');
    const phrases = Array.from(phraseEls)
      .map((el) => (el.textContent || '').trim())
      .filter(Boolean);

    if (!phrases.length) return;

    const chosen = phrases[Math.floor(Math.random() * phrases.length)];
    node.textContent = chosen;
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const mobileSortBar = document.getElementById('SortBy-mobile-bar');
  const mobileSortDrawer = document.getElementById('SortBy-mobile');
  
  if (mobileSortBar && mobileSortDrawer) {
    mobileSortBar.addEventListener('change', function() {
      mobileSortDrawer.value = this.value;
    });
    mobileSortDrawer.addEventListener('change', function() {
      mobileSortBar.value = this.value;
    });
  }
});
